import { MenuItem, toast } from "../../vendor/ds-react";
import {
  ContextMenuItem,
  ContextMenuSeparator,
} from "../../vendor/src/features/remotion-editor/editor/context-menu";
import {
  useCurrentStateAsRef,
  useFullState,
  useWriteContext,
} from "../../vendor/src/features/remotion-editor/editor/utils/use-context";
import { hasPendingTimelineEdit } from "./edit-ownership";
import { clipAudioMenuAction } from "./clip-audio-menu-action";
import { editorUserMessage } from "../../protocol/user-message";

export function ClipAudioContextMenu({ clipId }: { clipId: string }) {
  const state = useFullState(),
    current = useCurrentStateAsRef(),
    { setState } = useWriteContext();
  const clip = state.undoableState.items[clipId];
  if (clip?.type !== "video") return null;
  const asset = state.undoableState.assets[clip.assetId];
  const track = state.undoableState.tracks.find((t) =>
    t.items.includes(clipId),
  );
  const unavailable =
    !track ||
    track.locked ||
    asset?.type !== "video" ||
    !asset.hasAudioTrack ||
    hasPendingTimelineEdit(state);
  const run = (kind: "detach" | "restore") => {
    try {
      const before = current.current;
      const result = clipAudioMenuAction(before, clipId, kind, () =>
        crypto.randomUUID(),
      );
      setState({
        commitToUndoStack: true,
        update: (prev) =>
          prev.undoableState === before.undoableState
            ? { ...prev, ...result }
            : prev,
      });
    } catch (error) {
      toast({
        type: "error",
        description: editorUserMessage(
          error,
          "음성 작업을 완료하지 못했습니다. 다시 시도해 주세요.",
        ),
        toastOptions: { position: "top-center" },
      });
    }
  };
  return (
    <>
      <ContextMenuSeparator />
      <ContextMenuItem
        disabled={unavailable || clip.muteAudio === true}
        onPointerDown={(e) => e.stopPropagation()}
        onSelect={() => run("detach")}
      >
        <MenuItem
          size="md"
          showLeadingIcon={false}
          text="음성 분리"
          className="w-full"
        />
      </ContextMenuItem>
      <ContextMenuItem
        disabled={unavailable || clip.muteAudio !== true}
        onPointerDown={(e) => e.stopPropagation()}
        onSelect={() => run("restore")}
      >
        <MenuItem
          size="md"
          showLeadingIcon={false}
          text="음성 복구"
          className="w-full"
        />
      </ContextMenuItem>
    </>
  );
}
